import { useState } from 'react'
import {
  ArrayField,
  Datagrid,
  EditButton,
  EmailField,
  FormTab,
  ListButton,
  TextField,
  TopToolbar,
  useRecordContext,
  useResourceContext,
} from 'react-admin'
import { useParams } from 'react-router-dom'
import {
  CompactShow,
  CreateButton,
  CustomerTextField,
  EditAppointments,
  EditAttachments,
  EditComments,
  LinkToRecord,
} from '~/components'
import { customerName } from '~/helpers/resources/customers'

const CustomerTitle = () => {
  const record = useRecordContext()
  return record ? <span>Kunde: {customerName(record)}</span> : null
}

const CustomerShowActions = ({ data }) => (
  <TopToolbar>
    <ListButton label='ra.action.back' />
    <EditButton record={data} />
  </TopToolbar>
)

const CustomerShow = (props) => {
  // react-admin 5 passes a Show page no props: `props.resource` and `props.id`
  // were undefined, so every attachment and comment created here was saved
  // with no relation at all.
  const resource = useResourceContext()
  const { id } = useParams()
  const relation = [resource, id]
  const stateCreateComment = useState(false)
  const stateCreateAttachment = useState(false)
  const stateCreateAppointment = useState(false)

  return (
    <CompactShow
      {...props}
      component='div'
      title={<CustomerTitle />}
      actions={<CustomerShowActions />}
      aside={[
        <TextField source='title' />,
        <TextField source='salutation' size='2' />,
        <CustomerTextField source='firstname' />,
        <CustomerTextField source='lastname' />,
        <CustomerTextField source='birth_name' />,
        <CustomerTextField source='birthday' />,
        <TextField source='nationality' />,
        <TextField source='identity_card_number' />,
        <ArrayField source='emails' currentSort={{ field: 'type', order: 'ASC' }} size='3'>
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source='type' label='resources.customers.array_fields.type' />
            <EmailField source='email' label='resources.customers.array_fields.email' />
          </Datagrid>
        </ArrayField>,
        <ArrayField source='phones' currentSort={{ field: 'type', order: 'ASC' }} size='3'>
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source='type' label='resources.customers.array_fields.type' />
            <TextField source='number' label='resources.customers.array_fields.phone' />
          </Datagrid>
        </ArrayField>,
        <TextField source='company' />,
        <TextField source='street' size='2' />,
        <TextField source='postal_code' />,
        <TextField source='city' />,
        <TextField source='country' />,
        <ArrayField
          source='customer_customer'
          label='resources.customers.types.relation_to'
          currentSort={{ field: 'type', order: 'ASC' }}
          size='3'
        >
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source='relation_type' label='resources.customers.array_fields.type' />
            <LinkToRecord resource='customers' id='related_customer_id'>
              <CustomerTextField source='related.firstname' />
              <CustomerTextField source='related.lastname' />
            </LinkToRecord>
          </Datagrid>
        </ArrayField>,
        <ArrayField
          source='related_customer'
          label='resources.customers.types.relation_from'
          currentSort={{ field: 'type', order: 'ASC' }}
          size='3'
        >
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source='relation_type' label='resources.customers.array_fields.type' />
            <LinkToRecord resource='customers' id='customer_id'>
              <CustomerTextField source='customer.firstname' />
              <CustomerTextField source='customer.lastname' />
            </LinkToRecord>
          </Datagrid>
        </ArrayField>,
        <ArrayField
          source='boat_customer'
          label='resources.customers.types.boats'
          currentSort={{ field: 'type', order: 'ASC' }}
          size='3'
        >
          <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source='relation_type' label='resources.customers.array_fields.type' />
            <LinkToRecord resource='boats' id='boat_id' linkType='show' childrenSeparator=' – '>
              <TextField source='boat.name' />
              <TextField source='boat.model' />
            </LinkToRecord>
          </Datagrid>
        </ArrayField>,
      ]}
      // One per tab: Kommentare, Anhänge, Termine.
      toolbars={[
        <CreateButton
          onClick={(e) => {
            e.stopPropagation()
            stateCreateComment[1](true)
          }}
        />,
        <CreateButton
          onClick={(e) => {
            e.stopPropagation()
            stateCreateAttachment[1](true)
          }}
        />,
        <CreateButton
          onClick={(e) => {
            e.stopPropagation()
            stateCreateAppointment[1](true)
          }}
        />,
      ]}
    >
      <FormTab label='resources.comments.title'>
        <ArrayField source='comments' label=''>
          <EditComments disableDelete relation={relation} stateCreate={stateCreateComment} />
        </ArrayField>
      </FormTab>

      <FormTab label='resources.attachments.title'>
        <ArrayField source='attachments' label=''>
          <EditAttachments disableDelete relation={relation} stateCreate={stateCreateAttachment} />
        </ArrayField>
      </FormTab>

      <FormTab label='resources.appointments.title'>
        <ArrayField source='appointment_customer' label=''>
          <EditAppointments
            disableDelete
            relation={relation}
            stateCreate={stateCreateAppointment}
          />
        </ArrayField>
      </FormTab>
    </CompactShow>
  )
}

export default CustomerShow
